<section class="py-3 sm:py-5 min-h-screen">
  <div class="px-4 mx-auto max-w-screen-2xl lg:px-12 space-y-5">

    <!-- 🆕 HEADER DE PÁGINA: título + subtítulo -->
    <div class="flex items-center gap-2.5">
      <div class="w-10 h-10 rounded-lg bg-gradient-to-br from-primary-500 to-primary-700 flex items-center justify-center shadow-sm">
        <i class="fas fa-file-export text-white"></i>
      </div>
      <div>
        <h1 class="text-2xl font-bold text-gray-900 dark:text-white leading-none">Reportería</h1>
        <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">Genera, monitorea y descarga reportes operativos y de cartera</p>
      </div>
    </div>

    <!-- 🆕 LAYOUT 2 COLUMNAS: Form (izq) | Lista de reportes con info completa (der) -->
    <div class="grid grid-cols-1 lg:grid-cols-12 gap-5">

      <!-- ═══════ COLUMNA IZQUIERDA: SOLO el form (sticky) ═══════ -->
      <div class="lg:col-span-5 space-y-5">
        <div class="lg:sticky lg:top-4">

      <!-- SECCIÓN PRINCIPAL: Formulario nuevo reporte -->
      <div class="relative bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm" style="overflow: visible !important;">
      <div class="px-5 py-4 border-b border-gray-100 dark:border-gray-700 flex items-center justify-between">
        <div class="flex items-center gap-2">
          <i class="fas fa-plus-circle text-primary-600 dark:text-primary-400"></i>
          <h2 class="text-base font-semibold text-gray-900 dark:text-white">Nuevo reporte</h2>
        </div>
        <span class="text-xs text-gray-500 dark:text-gray-400">Configura los parámetros y genera</span>
      </div>

      <div class="px-5 py-5" style="overflow: visible !important;">
        <!-- Formulario de configuración -->
        <div style="overflow: visible !important;">
          <div class="grid grid-cols-1 gap-4" style="overflow: visible !important;">

            <!-- Selector de tipo de producto -->
            <div class="space-y-1.5">
              <label class="flex items-center text-xs font-semibold uppercase tracking-wider text-gray-600 dark:text-gray-400">
                <i class="fas fa-boxes mr-1.5 text-gray-400"></i>
                Tipo de Producto
              </label>
              <select [(ngModel)]="productType" (change)="onProductTypeChange()" class="form-control h-11">
                <option value="CREDIT" *ngIf="hasAnyCreditReport()">Crédito</option>
                <option value="INSURANCE" *ngIf="hasAnyInsuranceReport()">Seguro</option>
              </select>
            </div>

            <!-- Selector de tipo de reporte -->
            <div class="space-y-1.5">
              <label class="flex items-center text-xs font-semibold uppercase tracking-wider text-gray-600 dark:text-gray-400">
                <i class="fas fa-chart-bar mr-1.5 text-gray-400"></i>
                Tipo de Reporte
              </label>
              <select (change)="setNewType()" [(ngModel)]="type" class="form-control h-11">
                <option value="" disabled selected>Selecciona un tipo de reporte</option>

                <!-- REPORTES DE SEGUROS -->
                <option value="21" *ngIf="productType === 'INSURANCE' && _auth.hasPermission('reportes.seguros.export')">
                  Reporte de Seguros
                </option>
                <option value="7" *ngIf="productType === 'INSURANCE' && _auth.hasPermission('reportes.clientes_domiciliados.export')">
                  Reporte de Clientes Domiciliados
                </option>
                <option value="24" *ngIf="productType === 'INSURANCE' && _auth.hasPermission('reportes.pagos_seguros.export')">
                  Reporte de Pagos de Seguros Mercantil
                </option>
                <option value="39" *ngIf="productType === 'INSURANCE' && _auth.hasPermission('reportes.pagos_seguros.export')">
                  Reporte de Pagos de Seguros Caracas
                </option>
                <!-- <option value="37" *ngIf="productType === 'INSURANCE' && _auth.hasPermission('reportes.pagos_seguros.export')">
                  Reporte de Pagos de Seguros Caracas 10%
                </option>
                <option value="38" *ngIf="productType === 'INSURANCE' && _auth.hasPermission('reportes.pagos_seguros.export')">
                  Reporte de Pagos de Seguros Caracas 11%
                </option> -->
                <option value="35" *ngIf="productType === 'INSURANCE' && _auth.hasPermission('reportes.operativo_seguros.export')">
                  Reporte Operativo Seguros Mercantil - CrédiTotal
                </option>
                <option value="36" *ngIf="productType === 'INSURANCE' && _auth.hasPermission('reportes.operativo_seguros.export')">
                  Reporte Operativo Seguros Mercantil - Portal Externo
                </option>
                <option value="40" *ngIf="productType === 'INSURANCE' && _auth.hasPermission('reportes.operativo_seguros_caracas.export')">
                  Reporte Operativo Seguros Caracas
                </option>
                <!-- <option value="32" *ngIf="productType === 'INSURANCE' && _auth.hasPermission('reportes.operativo_seguros_caracas.export')">
                  Reporte Operativo Seguros Caracas 10%
                </option>
                <option value="34" *ngIf="productType === 'INSURANCE' && _auth.hasPermission('reportes.operativo_seguros_caracas.export')">
                  Reporte Operativo Seguros Caracas 11%
                </option> -->
                <option value="29" *ngIf="productType === 'INSURANCE' && _auth.hasPermission('reportes.cartera_seguros.export')">
                  Cartera de Seguros
                </option>
                <option value="30" *ngIf="productType === 'INSURANCE' && _auth.hasPermission('reportes.pagos_seguro_kredit.export')">
                  Reporte de Pagos Seguro Kredit
                </option>
                <option value="31" *ngIf="productType === 'INSURANCE' && _auth.hasPermission('reportes.cuotas_seguros.export')">
                  Reporte de Cuotas
                </option>
                <!-- Reportes SAP consolidados por aseguradora (NUEVOS) -->
                <option value="41" *ngIf="!env?.productio && productType === 'INSURANCE' && _auth.hasPermission('reportes.sap_mercantil_insurer.export')">
                  Reporte SAP Pagos - Seguros Mercantil
                </option>
                <option value="42" *ngIf="!env?.productio && productType === 'INSURANCE' && _auth.hasPermission('reportes.sap_caracas_insurer.export')">
                  Reporte SAP Pagos - Seguros Caracas
                </option>

                <!-- Reportes SAP por banco (DEPRECADOS — reemplazados por los consolidados de arriba) -->
                <option value="25" hidden *ngIf="!env?.productio && productType === 'INSURANCE' && _auth.hasPermission('reportes.sap_bdv_seguros.export')">
                  [DEPRECADO] Reporte SAP Pagos BDV - Seguros
                </option>
                <option value="26" hidden *ngIf="!env?.productio && productType === 'INSURANCE' && _auth.hasPermission('reportes.sap_mercantil_seguros.export')">
                  [DEPRECADO] Reporte SAP Pagos Mercantil - Seguros
                </option>
                <option value="28" hidden *ngIf="!env?.productio && productType === 'INSURANCE' && _auth.hasPermission('reportes.sap_plaza_seguros.export')">
                  [DEPRECADO] Reporte SAP Pagos Banco Plaza - Seguros
                </option>

                <!-- REPORTES DE CRÉDITO -->
                <option value="6" *ngIf="productType === 'CREDIT' && _auth.hasPermission('reportes.cartera_clientes.export')">
                  Reporte de Cartera de Clientes
                </option>
                <option value="3" *ngIf="productType === 'CREDIT' && _auth.hasPermission('reportes.cartera_credito.export')">
                  Reporte de Cartera de Crédito
                </option>
                <option value="7" *ngIf="productType === 'CREDIT' && _auth.hasPermission('reportes.clientes_domiciliados.export')">
                  Reporte de Clientes Domiciliados
                </option>
                <option value="2" *ngIf="productType === 'CREDIT' && _auth.hasPermission('reportes.cuotas.export')">
                  Reporte de Cuotas
                </option>
                <option value="15" *ngIf="productType === 'CREDIT' && _auth.hasPermission('reportes.distribucion_pagos.export')">
                  Reporte de Distribución de Pagos
                </option>
                <option value="20" *ngIf="productType === 'CREDIT' && _auth.hasPermission('reportes.biometria.export')">
                  Reporte de Biometría
                </option>
                <option value="4" *ngIf="productType === 'CREDIT' && _auth.hasPermission('reportes.pagos.export')">
                  Reporte de Pagos
                </option>
                <option value="17" *ngIf="productType === 'CREDIT' && _auth.hasPermission('reportes.estadistica_registros.export')">
                  Reporte de Estadística de Registros
                </option>
                <option value="18" *ngIf="productType === 'CREDIT' && _auth.hasPermission('reportes.pagos_penalidades.export')">
                  Reporte de Pagos a Penalidades
                </option>
                <option value="19" *ngIf="productType === 'CREDIT' && _auth.hasPermission('reportes.penalidades.export')">
                  Reporte de Penalidades
                </option>
                <option value="33" *ngIf="productType === 'CREDIT' && _auth.hasPermission('reportes.fees_reactivacion.export')">
                  Reporte de Estado de Fees de Reactivación (C004)
                </option>
                <option value="37" *ngIf="productType === 'CREDIT' && _auth.hasPermission('reportes.cartera_360.export')">
                  🎯 Reporte 360 — Salud de Cartera + Análisis Predictivo (NIIF 9)
                </option>
                <option value="22" *ngIf="productType === 'CREDIT' && _auth.hasPermission('reportes.planes_clientes.export')">
                  Reporte de Planes por Clientes
                </option>
                <option value="23" *ngIf="productType === 'CREDIT' && _auth.hasPermission('reportes.bdv_transacciones.export')">
                  BDV BP Transacciones Encoladas
                </option>
                <option value="8" *ngIf="!env?.productio && productType === 'CREDIT' && _auth.hasPermission('reportes.pagos_sap.export')">
                  Reporte Pagos SAP
                </option>
                <option value="9" *ngIf="!env?.productio && productType === 'CREDIT' && _auth.hasPermission('reportes.giros_sap.export')">
                  Reporte Giros SAP
                </option>
                <option value="46" *ngIf="!env?.productio && productType === 'CREDIT' && _auth.hasPermission('reportes.pagos_sap_nuevo.export')">
                  Reporte Pagos SAP Nuevo
                </option>
                <option value="48" *ngIf="!env?.productio && productType === 'CREDIT' && _auth.hasPermission('reportes.pagos_sap_perdidas_incobrables.export')">
                  Reporte Pagos SAP Pérdidas Incobrables
                </option>
                <option value="47" *ngIf="!env?.productio && productType === 'CREDIT' && _auth.hasPermission('reportes.giros_sap_nuevo.export')">
                  Reporte Giros SAP Nuevo
                </option>
                <option value="43" *ngIf="productType === 'CREDIT' && _auth.hasPermission('reportes.sap_business_partner.export')">
                  Reporte de SAP Business Partner
                </option>
                <option value="44" *ngIf="productType === 'CREDIT' && _auth.hasPermission('reportes.sap_partidas_abiertas.export')">
                  Reporte de SAP de Partidas Abiertas
                </option>
                <option value="45" *ngIf="productType === 'CREDIT' && _auth.hasPermission('reportes.sap_perdidas_incobrables.export')">
                  Reporte de SAP de Pérdidas Incobrables
                </option>
              </select>
            </div>

            <!-- Selector de fecha única -->
            <div class="space-y-2" *ngIf="type == 1">
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">
                <i class="fas fa-calendar-alt mr-2"></i>
                Fecha
              </label>
              <div class="form-control d-flex align-items-center" style="height: 58px;">
                <span class="d-block d-md-none w-100">
                  <mbsc-date (onSet)="dateSet($event)" [(ngModel)]="date_base" [options]="mobileSettings" placeholder="dd/mm/aaaa"></mbsc-date>
                </span>
                <span class="d-none d-md-block w-100">
                  <mbsc-date (onSet)="dateSet($event)" [(ngModel)]="date_base" [options]="desktopSettings" placeholder="dd/mm/aaaa"></mbsc-date>
                </span>
              </div>
            </div>

            <!-- 🆕 Selector de día único para reportes SAP por día
                 (Pagos SAP, Giros SAP, Pagos/Giros SAP Nuevo y Pagos SAP Pérdidas Incobrables) -->
            <div class="space-y-1.5" *ngIf="type == 8 || type == 9 || type == 46 || type == 47 || type == 48">
              <label class="flex items-center text-xs font-semibold uppercase tracking-wider text-gray-600 dark:text-gray-400">
                <i class="fas fa-calendar-alt mr-1.5 text-gray-400"></i>
                Fecha
              </label>
              <input type="date" [(ngModel)]="sapDate" class="form-control h-11" />
              <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">
                <i class="fas fa-info-circle mr-1"></i>
                Se genera el reporte SAP para el día seleccionado
              </p>
            </div>

            <!-- Selector de rango de fechas -->
            <div class="space-y-2" *ngIf="type == 2 || type == 4 || type == 15 || type == 20 || type == 21 || type == 24 || type == 25 || type == 26 || type == 27 || type == 28 || type == 29 || type == 30 || type == 31 || type == 32 || type == 34 || type == 35 || type == 36 || type == 37 || type == 38 || type == 39 || type == 40 || type == 41 || type == 42">
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">
                <i class="fas fa-calendar-week mr-2"></i>
                Rango de fechas
              </label>
              <div class="form-control d-flex align-items-center" style="height: 58px;">
                <input
                  id="demo-external"
                  (onSet)="birthdaySet()"
                  [(ngModel)]="range"
                  mbsc-range
                  class="w-100 bg-transparent border-0 focus:ring-0 focus:outline-none"
                  [mbsc-options]="dateSetting"
                  #externalRange="mobiscroll"
                />
              </div>
            </div>

            <!-- Selector de tipo de producto para domiciliación (INSURANCE) -->
            <div class="space-y-2" *ngIf="type == 7 && productType === 'INSURANCE'">
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">
                <i class="fas fa-box mr-2"></i>
                Tipo de Producto Domiciliado
              </label>
              <select [(ngModel)]="domiciliation_product_type" (change)="onDomiciliationProductTypeChange()" class="form-control" style="height: 58px;">
                <option value="ALL">Todos los seguros</option>
                <option value="SEGUROS_MERCANTIL">Seguros Mercantil</option>
                <option value="SEGUROS_CARACAS">Seguros Caracas</option>
              </select>
              <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">
                <i class="fas fa-info-circle mr-1"></i>
                Filtra los clientes domiciliados por tipo de seguro
              </p>
            </div>


          </div>

          <!-- Botón de exportar -->
          <div class="mt-6">
            <!-- 🆕 2026-05-25 — Aviso cuando ya hay un proceso del mismo tipo en curso -->
            <div *ngIf="getInflightForCurrentType() as inflight"
                 class="mb-3 p-3 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-300 dark:border-yellow-700 rounded-md text-sm">
              <div class="flex items-start gap-2">
                <i class="fas fa-exclamation-triangle text-yellow-600 dark:text-yellow-400 mt-0.5"></i>
                <div class="flex-1">
                  <div class="font-medium text-yellow-800 dark:text-yellow-300">
                    Ya hay un proceso en curso de este reporte
                  </div>
                  <div class="text-xs text-yellow-700 dark:text-yellow-400 mt-0.5">
                    Iniciado hace {{ getElapsedHuman(inflight?.date_start) }}
                    <span *ngIf="inflight?.executed_by"> por <b>{{ inflight.executed_by }}</b></span>
                    <span *ngIf="inflight?.progress?.percentage != null"> · {{ inflight.progress.percentage }}%</span>
                  </div>
                  <div class="text-xs text-yellow-700 dark:text-yellow-400 mt-1">
                    Esperá a que termine o cancelalo desde la lista de procesos para generar uno nuevo.
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="type && !puedeAccionReporte('generate')" class="text-sm text-gray-600 bg-gray-50 border border-gray-200 rounded-lg px-4 py-3">
              <i class="fas fa-info-circle mr-1 text-gray-400"></i> Solo tienes permiso para ver y descargar este reporte.
            </div>
            <button *ngIf="!type || puedeAccionReporte('generate')"
              type="button"
              class="w-full md:w-auto inline-flex items-center justify-center px-6 py-3 text-base font-medium text-white bg-blue-600 border border-transparent rounded-lg shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-blue-600 transition-colors duration-200"
              (click)="generate()"
              [disabled]="!type || loadingXls || !!getInflightForCurrentType()"
              [title]="getInflightForCurrentType() ? 'Ya hay un proceso de este tipo en curso' : 'Generar reporte'">
              <i class="fas mr-2" [ngClass]="loadingXls ? 'fa-spinner fa-spin' : (getInflightForCurrentType() ? 'fa-ban' : 'fa-download')"></i>
              <span *ngIf="!loadingXls && !getInflightForCurrentType()">Generar Reporte</span>
              <span *ngIf="loadingXls">Generando...</span>
              <span *ngIf="!loadingXls && getInflightForCurrentType()">Proceso en curso — esperá a que termine</span>
            </button>
          </div>
        </div>
      </div>
    </div>

      <!-- 🆕 2026-05-24 — Card "Procesos en curso" debajo del form -->
      <div *ngIf="procesosVisibles.length > 0"
           class="mt-4 bg-white dark:bg-gray-800 rounded-xl border border-yellow-200 dark:border-yellow-900/40 shadow-sm overflow-hidden">
        <div class="px-5 py-3 border-b border-yellow-100 dark:border-yellow-900/30 bg-yellow-50/40 dark:bg-yellow-900/10 flex items-center justify-between">
          <div class="flex items-center gap-2">
            <span class="relative flex h-2 w-2">
              <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-yellow-400 opacity-75"></span>
              <span class="relative inline-flex rounded-full h-2 w-2 bg-yellow-500"></span>
            </span>
            <h3 class="text-sm font-semibold text-gray-900 dark:text-gray-100">
              Procesos en curso
            </h3>
            <span class="text-xs text-gray-500 dark:text-gray-400">({{ procesosVisibles.length }})</span>
          </div>
          <span class="text-[10px] text-gray-500 dark:text-gray-400">Click para ver detalle</span>
        </div>
        <ul class="divide-y divide-gray-100 dark:divide-gray-700">
          <li *ngFor="let p of procesosVisibles"
              (click)="selectActiveProcess(p)"
              class="px-5 py-3 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors">
            <div class="flex items-center justify-between gap-2 mb-1.5">
              <div class="flex items-center gap-2 min-w-0">
                <i class="fas fa-spinner fa-spin text-blue-500 text-xs flex-shrink-0"></i>
                <span class="text-sm font-medium text-gray-900 dark:text-gray-100 truncate">{{ getFriendlyReportName(p?.type) }}</span>
              </div>
              <span class="text-xs font-mono text-blue-600 dark:text-blue-400 flex-shrink-0">{{ p?.progress?.percentage || 0 }}%</span>
            </div>
            <div class="w-full h-1 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden mb-1">
              <div class="h-full bg-blue-500 dark:bg-blue-400 transition-all duration-500" [style.width.%]="p?.progress?.percentage || 0"></div>
            </div>
            <div class="flex items-center justify-between text-[10px] text-gray-500 dark:text-gray-400">
              <span class="truncate"><i class="fas fa-user-circle mr-0.5"></i> {{ p?.executed_by || 'sin registro' }}</span>
              <span class="font-mono">{{ getElapsedHuman(p?.date_start) }}</span>
            </div>
          </li>
        </ul>
      </div>

        </div>
      </div>
      <!-- ═══════ /COLUMNA IZQUIERDA (form sticky) ═══════ -->

      <!-- ═══════ COLUMNA DERECHA: Lista de reportes con info completa ═══════ -->
      <div class="lg:col-span-7 space-y-3">

        <!-- Header de la lista -->
        <div class="flex items-center justify-between px-1">
          <div class="flex items-center gap-2">
            <h2 class="text-base font-semibold text-gray-900 dark:text-white">Reportes</h2>
            <span *ngIf="trace_documets?.length > 0" class="text-xs text-gray-500 dark:text-gray-400">({{ trace_documets?.length }})</span>
          </div>
          <div class="flex items-center gap-2">
            <button (click)="openHistoryDrawer()"
                    class="inline-flex items-center px-3 py-1.5 text-xs font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                    title="Ver historial completo">
              <i class="fas fa-history mr-1.5"></i>Ver historial
            </button>
            <button (click)="setNewType()"
                    class="flex items-center justify-center w-8 h-8 text-xs font-medium text-gray-500 rounded-md hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white transition-colors"
                    title="Refrescar lista">
              <i class="fas fa-sync-alt"></i>
            </button>
          </div>
        </div>

        <!-- Lista de cards FULL: cada card es autónoma con toda su info -->
        <div *ngFor="let item of trace_documets"
             class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm hover:shadow transition-all duration-150 border-l-4"
             [ngClass]="{
               'border-l-green-500': item?.state == 'COMPLETE',
               'border-l-yellow-500': item?.state == 'PENDING',
               'border-l-red-500': item?.state == 'ERROR',
               'border-l-gray-400': item?.state == 'CANCELED'
             }">

          <!-- Header card: estado + nombre + acción -->
          <div class="px-5 py-3 flex items-start justify-between gap-3 border-b border-gray-100 dark:border-gray-700">
            <div class="flex-1 min-w-0">
              <div class="flex items-center gap-2 mb-1">
                <span class="inline-flex items-center text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded" [ngClass]="{
                  'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400': item?.state == 'COMPLETE',
                  'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400': item?.state == 'PENDING',
                  'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400': item?.state == 'ERROR',
                  'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300': item?.state == 'CANCELED'
                }">
                  <span class="w-1.5 h-1.5 rounded-full mr-1" [ngClass]="{
                    'bg-green-500': item?.state == 'COMPLETE',
                    'bg-yellow-500 animate-pulse': item?.state == 'PENDING',
                    'bg-red-500': item?.state == 'ERROR',
                    'bg-gray-400': item?.state == 'CANCELED'
                  }"></span>
                  <span *ngIf="item?.state == 'COMPLETE'">Completado</span>
                  <span *ngIf="item?.state == 'PENDING'">En curso</span>
                  <span *ngIf="item?.state == 'ERROR'">Error</span>
                  <span *ngIf="item?.state == 'CANCELED'">Cancelado</span>
                </span>
              </div>
              <h3 class="text-base font-bold text-gray-900 dark:text-gray-100 truncate flex items-center gap-2">
                <!-- 🆕 Badge "Preservado" si está marcado -->
                <i *ngIf="item?.preserved" class="fas fa-thumbtack text-amber-500" title="Reporte preservado — no se borrará"></i>
                <span *ngIf="item?.preserved && item?.preserved_name" class="text-amber-700 dark:text-amber-400">{{ item?.preserved_name }}</span>
                <span *ngIf="!item?.preserved || !item?.preserved_name">{{ getFriendlyReportName(item?.type) }}</span>
              </h3>
            </div>

            <!-- Acción primaria a la derecha del header -->
            <div class="flex-shrink-0 flex items-center gap-2">
              <button *ngIf="item?.state == 'COMPLETE' && item?.url && !item?.params?.data?.files"
                      (click)="dowloader_document(item)"
                      class="inline-flex items-center px-3.5 py-1.5 text-xs font-semibold text-white bg-primary-600 hover:bg-primary-700 dark:bg-primary-500 dark:hover:bg-primary-600 rounded-md shadow-sm transition-colors">
                <i class="fas fa-download mr-1.5"></i>Descargar
              </button>
              <!-- 🆕 Preservar / Quitar preservación (solo en COMPLETE) -->
              <button *ngIf="item?.state == 'COMPLETE' && !item?.preserved"
                      (click)="preserveTrace(item)"
                      class="inline-flex items-center px-3 py-1.5 text-xs font-medium text-amber-700 dark:text-amber-300 bg-white dark:bg-transparent border border-amber-300 dark:border-amber-700 hover:bg-amber-50 dark:hover:bg-amber-900/20 rounded-md transition-colors"
                      title="Preservar este reporte (no se borrará en cleanup automático)">
                <i class="fas fa-thumbtack mr-1.5"></i>Preservar
              </button>
              <button *ngIf="item?.state == 'COMPLETE' && item?.preserved"
                      (click)="unpreserveTrace(item)"
                      class="inline-flex items-center px-3 py-1.5 text-xs font-medium text-gray-600 dark:text-gray-400 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 hover:bg-amber-100 dark:hover:bg-amber-900/40 rounded-md transition-colors"
                      title="Quitar preservación — volverá al cleanup">
                <i class="fas fa-thumbtack mr-1.5"></i>Preservado · quitar
              </button>
              <button *ngIf="item?.state == 'PENDING' && !item?.cancel_requested && puedeAccionReporte('stop')"
                      (click)="cancelTrace(item)"
                      class="inline-flex items-center px-3 py-1.5 text-xs font-medium text-red-700 dark:text-red-300 bg-white dark:bg-transparent border border-red-300 dark:border-red-700 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-md transition-colors"
                      title="Detener este reporte (pedirá razón)">
                <i class="fas fa-stop-circle mr-1.5"></i>Detener
              </button>
              <span *ngIf="item?.cancel_requested && item?.state == 'PENDING'"
                    class="inline-flex items-center px-3 py-1.5 text-xs italic text-orange-700 dark:text-orange-300 bg-orange-50 dark:bg-orange-900/20 rounded-md">
                <i class="fas fa-hourglass-half mr-1.5"></i>Cancelando…
              </span>
            </div>
          </div>

          <!-- Body: metadata grid (ejecutor, duración, inicio, fin) -->
          <div class="px-5 py-3 grid grid-cols-2 gap-3 text-sm">
            <div>
              <div class="text-[10px] font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400 mb-0.5">
                <i class="fas fa-user-circle mr-1"></i>Ejecutado por
              </div>
              <div class="font-medium text-gray-900 dark:text-gray-100 truncate" *ngIf="item?.executed_by">{{ item.executed_by }}</div>
              <div class="italic text-gray-400 text-xs" *ngIf="!item?.executed_by">— sin registro</div>
            </div>
            <div>
              <div class="text-[10px] font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400 mb-0.5">
                <i class="fas fa-stopwatch mr-1"></i>Duración
              </div>
              <div class="font-mono font-medium text-gray-900 dark:text-gray-100" *ngIf="item?.state == 'COMPLETE' && item?.date_end">
                {{ getDurationHuman(item?.date_start, item?.date_end) }}
              </div>
              <div *ngIf="item?.state == 'PENDING'">
                <div class="font-mono text-blue-600 dark:text-blue-400">
                  {{ getElapsedHuman(item?.date_start) }} <span class="text-[10px] text-gray-400">transcurridos</span>
                </div>
                <!-- 🆕 Tiempo aproximado basado en histórico de ejecuciones del mismo tipo -->
                <div *ngIf="getAvgDurationMin(item?.type) as avgMin" class="text-[10px] text-gray-500 dark:text-gray-400 mt-0.5">
                  <i class="fas fa-history mr-0.5"></i>~{{avgMin}}m promedio<span *ngIf="getStatCount(item?.type) > 0" class="text-gray-400"> ({{ getStatCount(item?.type) }} ejec.)</span>
                </div>
              </div>
              <div class="italic text-gray-400 text-xs" *ngIf="item?.state == 'ERROR' || item?.state == 'CANCELED'">—</div>
            </div>
            <!-- Rango de fechas seleccionado al generar (solo para reportes que lo usan).
                 Render en UTC porque el backend persiste como new Date('yyyy-MM-dd')
                 (medianoche UTC) y sin esta opción Venezuela (UTC-4) muestra día anterior. -->
            <div class="col-span-2" *ngIf="item?.start_date">
              <div class="text-[10px] font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400 mb-0.5">
                <i class="fas fa-calendar-day mr-1 text-purple-500"></i>Rango de fechas seleccionadas
              </div>
              <div class="font-mono text-xs text-gray-800 dark:text-gray-200">
                {{ item?.start_date | date: 'dd/MM/yyyy':'UTC' }}
                <span *ngIf="item?.end_date"> - {{ item?.end_date | date: 'dd/MM/yyyy':'UTC' }}</span>
              </div>
            </div>

            <!-- Fecha de generación consolidada: inicio - fin de la ejecución -->
            <div class="col-span-2">
              <div class="text-[10px] font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400 mb-0.5">
                <i class="fas fa-clock mr-1 text-blue-500"></i>Fecha de generación (Inicio y Fin)
              </div>
              <div class="font-mono text-xs text-gray-800 dark:text-gray-200">
                {{ item?.date_start | date: 'dd/MM/yyyy HH:mm:ss' }}
                <span *ngIf="item?.date_end"> - {{ item?.date_end | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
                <span *ngIf="!item?.date_end && item?.state == 'PENDING'" class="italic text-gray-400"> - en curso…</span>
                <span *ngIf="!item?.date_end && item?.state != 'PENDING'" class="italic text-gray-400"> - —</span>
              </div>
            </div>
          </div>

          <!-- Barra de progreso GENÉRICA (cualquier PENDING con progress definido) -->
          <!-- ver docs/reportes/REPORT_CARD_REQUIREMENTS.md — sección "Lo que el card MUESTRA" -->
          <div *ngIf="item?.state == 'PENDING' && (item?.progress?.percentage != null || item?.progress?.status)"
               class="px-5 pb-3 pt-1 border-t border-gray-100 dark:border-gray-700">
            <div class="flex items-center justify-between mb-1.5 text-xs">
              <span class="font-medium text-blue-700 dark:text-blue-300">
                <i class="fas fa-spinner fa-spin mr-1"></i>
                {{ item?.progress?.current_phase_description || item?.progress?.current_phase || item?.progress?.current_sheet || 'Procesando' }}
              </span>
              <span class="font-mono font-bold text-blue-900 dark:text-blue-200">{{ item?.progress?.percentage || 0 }}%</span>
            </div>
            <div class="w-full h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden mb-2">
              <div class="h-full bg-blue-500 dark:bg-blue-400 transition-all duration-500"
                   [style.width.%]="item?.progress?.percentage || 0"></div>
            </div>
            <div class="grid grid-cols-2 md:grid-cols-4 gap-x-3 gap-y-1 text-xs">
              <!-- Procesado: soporta tanto V3 (processed_payments) como genérico (processed) -->
              <div *ngIf="(item?.progress?.processed_payments != null) || (item?.progress?.processed != null)">
                <span class="text-gray-500 dark:text-gray-400">Procesado</span>
                <div class="font-medium text-gray-800 dark:text-gray-200">
                  {{ (item?.progress?.processed_payments ?? item?.progress?.processed) | number }}{{ (item?.progress?.total_payments || item?.progress?.total) ? ' / ' + ((item?.progress?.total_payments ?? item?.progress?.total) | number) : '' }}
                </div>
              </div>
              <div *ngIf="item?.progress?.rate_per_second">
                <span class="text-gray-500 dark:text-gray-400">Velocidad</span>
                <div class="font-medium text-gray-800 dark:text-gray-200">{{ item?.progress?.rate_per_second | number }}/s</div>
              </div>
              <div *ngIf="item?.progress?.eta_human && item?.progress?.eta_human !== '—'">
                <span class="text-gray-500 dark:text-gray-400">ETA</span>
                <div class="font-medium text-gray-800 dark:text-gray-200">{{ item?.progress?.eta_human }}</div>
              </div>
              <div *ngIf="item?.progress?.sheets > 0 || item?.progress?.current_sheet">
                <span class="text-gray-500 dark:text-gray-400">Hoja</span>
                <div class="font-medium text-gray-800 dark:text-gray-200">
                  {{ item?.progress?.sheets || item?.progress?.current_sheet }}<span *ngIf="item?.progress?.rows_in_current_sheet" class="text-gray-500"> · {{ item.progress.rows_in_current_sheet | number }} filas</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Mensaje de error -->
          <div *ngIf="item?.state == 'ERROR' && item?.description"
               class="px-5 py-2.5 border-t border-red-100 dark:border-red-900/30 bg-red-50/50 dark:bg-red-900/10">
            <div class="flex items-start gap-2 text-xs text-red-700 dark:text-red-400">
              <i class="fas fa-exclamation-triangle mt-0.5"></i>
              <span>{{ item?.description }}</span>
            </div>
          </div>

          <!-- Mensaje cancelado: incluye QUIÉN canceló y CUÁNDO -->
          <div *ngIf="item?.state == 'CANCELED' && (item?.description || item?.canceled_by)"
               class="px-5 py-2.5 border-t border-gray-100 dark:border-gray-700 bg-gray-50/50 dark:bg-gray-800/50">
            <div class="flex items-start gap-2 text-xs text-gray-600 dark:text-gray-400">
              <i class="fas fa-info-circle mt-0.5"></i>
              <div class="flex-1">
                <div *ngIf="item?.description">{{ item?.description }}</div>
                <div *ngIf="item?.canceled_by" class="mt-0.5 text-[11px] text-gray-500">
                  <i class="fas fa-user mr-1"></i>Cancelado por <span class="font-medium">{{ item?.canceled_by }}</span>
                  <span *ngIf="item?.canceled_at"> · {{ item?.canceled_at | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Múltiples archivos: lista vertical con icono Excel + nombre + botón Descargar -->
          <div *ngIf="item?.params?.data?.files?.length > 0"
               class="border-t border-gray-100 dark:border-gray-700">
            <div class="px-5 py-2 text-[10px] font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400 bg-gray-50/50 dark:bg-gray-900/30">
              <i class="fas fa-folder-open mr-1.5"></i>{{ item.params.data.files.length }} archivo{{ item.params.data.files.length > 1 ? 's' : '' }} disponible{{ item.params.data.files.length > 1 ? 's' : '' }}
            </div>
            <ul class="divide-y divide-gray-100 dark:divide-gray-700">
              <li *ngFor="let file of item.params.data.files; let idx = index"
                  class="flex items-center justify-between gap-3 px-5 py-2.5 hover:bg-gray-50 dark:hover:bg-gray-700/30 transition-colors">
                <div class="flex items-center gap-2.5 min-w-0 flex-1">
                  <i class="fas fa-file-excel text-green-600 dark:text-green-400 flex-shrink-0"></i>
                  <span class="text-xs text-gray-800 dark:text-gray-200 truncate" [title]="file">{{ file }}</span>
                </div>
                <button (click)="dowloader_document({url: item?.url + file, api: item?.api})"
                        class="flex-shrink-0 inline-flex items-center px-3 py-1 text-xs font-medium text-primary-700 dark:text-primary-300 bg-primary-50 dark:bg-primary-900/20 border border-primary-200 dark:border-primary-800 rounded hover:bg-primary-100 dark:hover:bg-primary-900/40 transition-colors">
                  <i class="fas fa-download mr-1"></i>Descargar
                </button>
              </li>
            </ul>
          </div>
        </div>

        <!-- Empty state cuando no hay reportes -->
        <div *ngIf="trace_documets?.length === 0"
             class="bg-white dark:bg-gray-800 rounded-xl border border-dashed border-gray-300 dark:border-gray-700 px-5 py-12 text-center">
          <div class="mx-auto w-14 h-14 bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-700 dark:to-gray-800 rounded-2xl flex items-center justify-center mb-3">
            <i class="fas fa-file-export text-xl text-gray-400 dark:text-gray-500"></i>
          </div>
          <h3 class="text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">No hay reportes generados</h3>
          <p class="text-xs text-gray-500 dark:text-gray-400">Genera tu primer documento desde el formulario de la izquierda</p>
        </div>
      </div>
      <!-- ═══════ /COLUMNA DERECHA ═══════ -->

    </div>
    <!-- ═══════ /LAYOUT 2 COLUMNAS ═══════ -->

  </div>

  <!-- 🆕 2026-05-23 — DRAWER HISTORIAL COMPLETO -->
  <!-- ver docs/reportes/REPORT_CARD_REQUIREMENTS.md → "Vista de histórico" -->
  <div *ngIf="historyDrawerOpen"
       class="fixed inset-0 z-50 flex justify-end"
       (click)="closeHistoryDrawer()">
    <!-- Backdrop -->
    <div class="absolute inset-0 bg-black/40 dark:bg-black/60 backdrop-blur-sm transition-opacity"></div>

    <!-- Drawer panel -->
    <div class="relative bg-white dark:bg-gray-800 w-full max-w-5xl shadow-2xl flex flex-col h-full"
         (click)="$event.stopPropagation()">

      <!-- Header del drawer -->
      <div class="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700">
        <div class="flex items-center gap-3">
          <div class="w-10 h-10 rounded-lg bg-gradient-to-br from-primary-500 to-primary-700 flex items-center justify-center shadow-sm">
            <i class="fas fa-history text-white"></i>
          </div>
          <div>
            <h2 class="text-lg font-bold text-gray-900 dark:text-white leading-none">Historial de Reportes</h2>
            <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">
              <span *ngIf="!historyLoading">{{ historyTotal | number }} ejecuciones · página {{ historyPage }}/{{ historyTotalPages || 1 }}</span>
              <span *ngIf="historyLoading">Cargando…</span>
            </p>
          </div>
        </div>
        <div class="flex items-center gap-2">
          <!-- 🆕 Exportar histórico completo a XLSX (últimos 50 por tipo) -->
          <button (click)="exportHistoryXlsx()"
                  class="inline-flex items-center px-3 py-1.5 text-xs font-semibold text-white bg-green-600 hover:bg-green-700 rounded-md shadow-sm transition-colors"
                  title="Descargar XLSX con los últimos 50 traces de cada tipo">
            <i class="fas fa-file-excel mr-1.5"></i>Exportar histórico
          </button>
          <button (click)="closeHistoryDrawer()"
                  class="w-9 h-9 flex items-center justify-center rounded-md text-gray-400 hover:text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                  title="Cerrar (Esc)">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>

      <!-- Filtros -->
      <div class="px-6 py-3 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/40 grid grid-cols-2 md:grid-cols-5 gap-3">
        <div>
          <label class="block text-[10px] font-semibold uppercase tracking-wider text-gray-600 dark:text-gray-400 mb-1">Tipo</label>
          <select [(ngModel)]="historyFilters.type" (change)="applyHistoryFilters()" class="form-control text-xs h-9">
            <option value="">Todos</option>
            <option *ngFor="let t of getReportTypesForFilter()" [value]="t.value">{{ t.label }}</option>
          </select>
        </div>
        <div>
          <label class="block text-[10px] font-semibold uppercase tracking-wider text-gray-600 dark:text-gray-400 mb-1">Estado</label>
          <select [(ngModel)]="historyFilters.state" (change)="applyHistoryFilters()" class="form-control text-xs h-9">
            <option value="">Todos</option>
            <option value="COMPLETE">Completado</option>
            <option value="PENDING">En curso</option>
            <option value="ERROR">Error</option>
            <option value="CANCELED">Cancelado</option>
          </select>
        </div>
        <div>
          <label class="block text-[10px] font-semibold uppercase tracking-wider text-gray-600 dark:text-gray-400 mb-1">Ejecutor</label>
          <input type="text"
                 [(ngModel)]="historyFilters.executed_by"
                 (keyup.enter)="applyHistoryFilters()"
                 (blur)="applyHistoryFilters()"
                 placeholder="usuario o email"
                 class="form-control text-xs h-9" />
        </div>
        <div>
          <label class="block text-[10px] font-semibold uppercase tracking-wider text-gray-600 dark:text-gray-400 mb-1">Desde</label>
          <input type="date" [(ngModel)]="historyFilters.from" (change)="applyHistoryFilters()" class="form-control text-xs h-9" />
        </div>
        <div>
          <label class="block text-[10px] font-semibold uppercase tracking-wider text-gray-600 dark:text-gray-400 mb-1">Hasta</label>
          <input type="date" [(ngModel)]="historyFilters.to" (change)="applyHistoryFilters()" class="form-control text-xs h-9" />
        </div>
      </div>

      <!-- 🆕 Toggle de filtro Preservados -->
      <div class="px-6 py-2 border-b border-gray-200 dark:border-gray-700 flex items-center gap-2 bg-amber-50/30 dark:bg-amber-900/10">
        <i class="fas fa-thumbtack text-amber-500 text-xs"></i>
        <span class="text-xs font-semibold text-gray-700 dark:text-gray-300">Preservados:</span>
        <div class="flex items-center gap-1">
          <button (click)="historyFilterPreserved = ''; applyPreservedFilter()"
                  class="px-2 py-0.5 text-[11px] rounded transition-colors"
                  [ngClass]="historyFilterPreserved === '' ? 'bg-gray-800 text-white dark:bg-gray-200 dark:text-gray-900' : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300'">
            Todos
          </button>
          <button (click)="historyFilterPreserved = 'true'; applyPreservedFilter()"
                  class="px-2 py-0.5 text-[11px] rounded transition-colors"
                  [ngClass]="historyFilterPreserved === 'true' ? 'bg-amber-500 text-white' : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300'">
            Solo preservados
          </button>
          <button (click)="historyFilterPreserved = 'false'; applyPreservedFilter()"
                  class="px-2 py-0.5 text-[11px] rounded transition-colors"
                  [ngClass]="historyFilterPreserved === 'false' ? 'bg-gray-600 text-white' : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300'">
            Solo no-preservados
          </button>
        </div>
      </div>

      <!-- Acciones de filtros -->
      <div class="px-6 py-2 border-b border-gray-200 dark:border-gray-700 flex items-center justify-between">
        <button (click)="clearHistoryFilters()"
                class="text-xs font-medium text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white">
          <i class="fas fa-eraser mr-1"></i>Limpiar filtros
        </button>
        <button (click)="loadHistory()"
                class="text-xs font-medium text-primary-600 dark:text-primary-400 hover:underline">
          <i class="fas fa-sync-alt mr-1"></i>Refrescar
        </button>
      </div>

      <!-- Tabla -->
      <div class="flex-1 overflow-auto px-6 py-3">
        <table class="w-full text-xs" *ngIf="!historyLoading && historyItems.length > 0">
          <thead class="text-[10px] uppercase tracking-wider text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700">
            <tr>
              <th class="text-left py-2 pr-3">Estado</th>
              <th class="text-left py-2 pr-3">Reporte</th>
              <th class="text-left py-2 pr-3">Ejecutor</th>
              <th class="text-left py-2 pr-3 font-mono">Inicio</th>
              <th class="text-left py-2 pr-3 font-mono">Fin</th>
              <th class="text-left py-2 pr-3 font-mono">Duración</th>
              <th class="text-left py-2 pr-3">Cancelado por</th>
              <th class="text-right py-2"></th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
            <tr *ngFor="let h of historyItems"
                class="hover:bg-gray-50 dark:hover:bg-gray-700/40 transition-colors">
              <td class="py-2 pr-3">
                <span class="inline-flex items-center text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded" [ngClass]="{
                  'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400': h?.state == 'COMPLETE',
                  'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400': h?.state == 'PENDING',
                  'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400': h?.state == 'ERROR',
                  'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300': h?.state == 'CANCELED'
                }">
                  <span *ngIf="h?.state == 'COMPLETE'">OK</span>
                  <span *ngIf="h?.state == 'PENDING'">En curso</span>
                  <span *ngIf="h?.state == 'ERROR'">Error</span>
                  <span *ngIf="h?.state == 'CANCELED'">Cancel</span>
                </span>
              </td>
              <td class="py-2 pr-3 font-medium text-gray-900 dark:text-gray-100">
                <i *ngIf="h?.preserved" class="fas fa-thumbtack text-amber-500 mr-1" title="Preservado"></i>
                <span *ngIf="h?.preserved && h?.preserved_name" class="text-amber-700 dark:text-amber-400">{{ h?.preserved_name }}</span>
                <span *ngIf="!h?.preserved || !h?.preserved_name">{{ getFriendlyReportName(h?.type) }}</span>
                <span *ngIf="isLatestComplete(h) && !h?.preserved" class="ml-1.5 inline-flex items-center text-[9px] font-bold uppercase tracking-wider px-1 py-0.5 rounded bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400" title="Último COMPLETE de este tipo">
                  Último
                </span>
                <span *ngIf="h?.preserved" class="ml-1.5 inline-flex items-center text-[9px] font-bold uppercase tracking-wider px-1 py-0.5 rounded bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400" title="Preservado por usuario">
                  Preservado
                </span>
              </td>
              <td class="py-2 pr-3 text-gray-700 dark:text-gray-300">
                <span *ngIf="h?.executed_by">{{ h.executed_by }}</span>
                <span *ngIf="!h?.executed_by" class="italic text-gray-400">—</span>
              </td>
              <td class="py-2 pr-3 font-mono text-gray-700 dark:text-gray-300">{{ h?.date_start | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
              <td class="py-2 pr-3 font-mono text-gray-700 dark:text-gray-300">
                <span *ngIf="h?.date_end">{{ h?.date_end | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
                <span *ngIf="!h?.date_end" class="italic text-gray-400">—</span>
              </td>
              <td class="py-2 pr-3 font-mono text-gray-700 dark:text-gray-300">
                <span *ngIf="h?.date_end">{{ getDurationHuman(h?.date_start, h?.date_end) }}</span>
                <span *ngIf="!h?.date_end" class="italic text-gray-400">—</span>
              </td>
              <td class="py-2 pr-3 text-gray-700 dark:text-gray-300">
                <span *ngIf="h?.canceled_by" class="text-xs">{{ h.canceled_by }}</span>
                <span *ngIf="!h?.canceled_by" class="italic text-gray-400">—</span>
              </td>
              <td class="py-2 text-right">
                <div class="flex items-center justify-end gap-1">
                  <!-- 🆕 Descarga: último COMPLETE de cada tipo + cualquier preservado -->
                  <button *ngIf="h?.state == 'COMPLETE' && h?.url && (isLatestComplete(h) || h?.preserved)"
                          (click)="dowloader_document(h)"
                          class="inline-flex items-center px-2 py-1 text-[11px] font-medium text-primary-700 dark:text-primary-300 bg-primary-50 dark:bg-primary-900/20 border border-primary-200 dark:border-primary-800 rounded hover:bg-primary-100 dark:hover:bg-primary-900/40 transition-colors">
                    <i class="fas fa-download mr-1"></i>Descargar
                  </button>
                  <!-- 🆕 Preservar / quitar preservación desde el drawer -->
                  <button *ngIf="h?.state == 'COMPLETE' && !h?.preserved"
                          (click)="preserveTrace(h)"
                          class="inline-flex items-center px-1.5 py-1 text-[11px] text-amber-600 dark:text-amber-400 hover:bg-amber-50 dark:hover:bg-amber-900/20 rounded transition-colors"
                          title="Preservar">
                    <i class="fas fa-thumbtack"></i>
                  </button>
                  <button *ngIf="h?.state == 'COMPLETE' && h?.preserved"
                          (click)="unpreserveTrace(h)"
                          class="inline-flex items-center px-1.5 py-1 text-[11px] text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 rounded transition-colors"
                          title="Quitar preservación">
                    <i class="fas fa-times-circle"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Empty state -->
        <div *ngIf="!historyLoading && historyItems.length === 0"
             class="text-center py-16 text-gray-500 dark:text-gray-400">
          <i class="fas fa-inbox text-3xl mb-3 text-gray-300 dark:text-gray-600"></i>
          <div class="text-sm">No hay ejecuciones que coincidan con los filtros</div>
        </div>

        <!-- Loading state -->
        <div *ngIf="historyLoading" class="text-center py-16 text-gray-500 dark:text-gray-400">
          <i class="fas fa-spinner fa-spin text-2xl mb-3"></i>
          <div class="text-sm">Cargando historial…</div>
        </div>
      </div>

      <!-- Footer: paginación -->
      <div class="px-6 py-3 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/40 flex items-center justify-between text-xs"
           *ngIf="!historyLoading && historyItems.length > 0">
        <div class="text-gray-600 dark:text-gray-400">
          Mostrando <span class="font-semibold">{{ (historyPage - 1) * historyLimit + 1 }}</span> - <span class="font-semibold">{{ (historyPage - 1) * historyLimit + historyItems.length }}</span> de <span class="font-semibold">{{ historyTotal | number }}</span>
        </div>
        <div class="flex items-center gap-2">
          <button (click)="goToHistoryPage(1)"
                  [disabled]="historyPage === 1"
                  class="px-2 py-1 rounded hover:bg-gray-200 dark:hover:bg-gray-700 disabled:opacity-30 disabled:cursor-not-allowed">
            <i class="fas fa-angle-double-left"></i>
          </button>
          <button (click)="goToHistoryPage(historyPage - 1)"
                  [disabled]="historyPage === 1"
                  class="px-2 py-1 rounded hover:bg-gray-200 dark:hover:bg-gray-700 disabled:opacity-30 disabled:cursor-not-allowed">
            <i class="fas fa-angle-left"></i>
          </button>
          <span class="font-mono px-2">{{ historyPage }} / {{ historyTotalPages }}</span>
          <button (click)="goToHistoryPage(historyPage + 1)"
                  [disabled]="historyPage >= historyTotalPages"
                  class="px-2 py-1 rounded hover:bg-gray-200 dark:hover:bg-gray-700 disabled:opacity-30 disabled:cursor-not-allowed">
            <i class="fas fa-angle-right"></i>
          </button>
          <button (click)="goToHistoryPage(historyTotalPages)"
                  [disabled]="historyPage >= historyTotalPages"
                  class="px-2 py-1 rounded hover:bg-gray-200 dark:hover:bg-gray-700 disabled:opacity-30 disabled:cursor-not-allowed">
            <i class="fas fa-angle-double-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- ═══════ /DRAWER HISTORIAL ═══════ -->

</section>
